import React from 'react';


function CustomButton(props) {
  const { children,size,bgColor,textColor,hover,primary,width,onClick,type,disabled,classVal,loading,onKeyDown} = props;

  const handleKeyDown = (event) => {
    // Check if the pressed key is the space key
    if (event.key === ' ' || event.key === 'Spacebar') {
      // Prevent the default action (button click) when the space key is pressed
      event.preventDefault();
    }
  };

  return (
    <>
     <button
    class={disabled ? "disabledButton" : "primaryButton"}
    onClick={onClick}
    type={type}
    onKeyDown={handleKeyDown}
    disabled={disabled}
    loading={loading}
    >
            {children}
        </button>
    </>
   
  );
}

export default CustomButton;